import { IIdentityFormFields } from '../adapter'

export class IdentityFormUtils {
    private static DOM = {
        errorList: 'errorlist',
        formControls: 'form-container__field--controls',
        identityFormErrorMessage: 'identity-form__message--error'
    }

    /**
     * Returns form fields as a key value pair JSON
     *
     * @return {IIdentityFormFields}
     */
    public static getFields(): IIdentityFormFields {
        let data = [] as IIdentityFormFields

        const form = document.querySelector(`[data-id-form]`)

        if (form) {
            const fields = form.querySelectorAll<HTMLInputElement | HTMLSelectElement>(
                '[type=tel], [type=text], [type=email], select'
            )

            fields.forEach((field) => {
                // convert key to camel case
                const key = (field.name).replace(/[_][a-z1-9]/g, (group) => group.slice(-1).toUpperCase())

                // key value pair
                data = { ...data, [key]: field.value}
            })
        }
        return data
    }

    /**
     * Insert error message after the form controls
     *
     * @param errorMessage
     */
    public static showError(errorMessage: string) {
        const errorDiv = document.createElement('div')
        const errorList = document.createElement('ul')
        const errorListItem = document.createElement('li')
        const formControls = document.querySelector(`.${IdentityFormUtils.DOM.formControls}`)

        errorDiv.className = IdentityFormUtils.DOM.identityFormErrorMessage
        errorDiv.setAttribute('role', 'alert')

        errorList.className = IdentityFormUtils.DOM.errorList

        errorListItem.innerHTML = errorMessage

        errorList.appendChild(errorListItem)
        errorDiv.appendChild(errorList)

        if (formControls) {
            document.querySelector(`.${IdentityFormUtils.DOM.formControls}`).after(errorDiv)
        }
    }

    /**
     * Remove error message
     */
    public static clearError() {
        const error = document.querySelector(`.${IdentityFormUtils.DOM.identityFormErrorMessage}`)

        if (error) {
            error.remove()
        }
    }
}
